import {
	AuthInfo,
	Error,
	FAQ,
	Feedback,
	FeedbackDetail,
	FeedbackHistory,
	KnownIssues,
	NotFound,
	OrienticaGetHelp,
	OrienticaProduct,
	OwnershipTimeline,
	ProductDetail,
	Scan,
} from 'pages';
import ProtectedRoute from '../../utils/ProtectedRoute';

export const orientica_theme = {
	palette: {
		primary: { main: '#84754E' },
		secondary: { main: '#862633', light: '#8626334d' },
		error: { main: '#d32f2f' },
		warning: { main: '#C40233' },
		info: { main: '#C8D3E6' },
		success: { main: '#648FCC' },
		background: { default: '#FFFFFF' },
		//	authenticated is customized, need module augmentation to make it work in Typescript
		//	https://stackoverflow.com/questions/60424596/cant-customize-color-palette-types-on-material-ui-theme-in-typescript
		authenticated: { main: 'rgb(46, 125, 50)' },
		defaultText: { main: '#84754E' },
		navBar: { main: '#FFFFFF', active: '#862633', inactive: '#8626334d' },
		authStatusBar: {
			main: '#84754E',
			success: '#648FCC',
			error: '#D32F2F',
			text: '#FFFFFF',
		},
		productChips: { main: '#00000014', icon: '#616161', text: '#000000DE' },
		productInfoBox: { main: '#F4F6F6', text: '#84754E' },
	},
	mixins: {
		toolbar: {
			height: '56px !important',
		},
	},
};

//	titleType:
//		0 - no title - default
//		1 - image - provide image name
//		2 - text - provide text code
//	leftBtnType:
//		0 - return button - default
//		1 - no button
//		2 - language select
export const orientica_routes = [
	{
		path: '/',
		element: <ProtectedRoute children={<Scan key="Scan" />} reqCam />,
		header: {
			titleType: 2,
			titleContent: 'nav.scan',
			leftBtnType: 1,
		},
	},
	{
		path: '/Scan',
		element: <ProtectedRoute children={<Scan key="Scan" />} reqCam />,
		header: {
			titleType: 2,
			titleContent: 'nav.scan',
		},
	},
	{
		path: '/Product',
		element: (
			<ProtectedRoute
				children={<OrienticaProduct key="Product" />}
				reqSDK
				reqProduct
			/>
		),
		header: {
			titleType: 2,
			titleContent: 'nav.productInfo',
		},
	},
	{
		path: '/ProductDetail',
		element: (
			<ProtectedRoute children={<ProductDetail key="ProductDetail" />} />
		),
		header: {
			titleType: 2,
			titleContent: 'nav.productInfo',
		},
	},
	{
		path: '/Error',
		element: <ProtectedRoute children={<Error key="Error" />} />,
		header: {
			titleType: 2,
			titleContent: 'nav.error',
		},
	},
	{
		path: '/KnownIssues',
		element: (
			<ProtectedRoute children={<KnownIssues key="KnownIssues" />} />
		),
		header: {
			titleType: 1,
		},
	},
	{
		path: '/AuthInfo',
		element: (
			<ProtectedRoute children={<AuthInfo key="AuthInfo" />} reqProduct />
		),
		header: {
			titleType: 2,
			titleContent: 'nav.auth.info',
		},
	},
	{
		path: '/Feedback',
		element: (
			<ProtectedRoute
				children={<Feedback key="Feedback" />}
				reqProduct
				reqAuth
			/>
		),
		header: {
			titleType: 2,
			titleContent: 'nav.feedback',
		},
	},
	{
		path: '/FeedbackHistory',
		element: (
			<ProtectedRoute
				children={<FeedbackHistory key="FeedbackHistory" />}
				reqProduct
				reqAuth
			/>
		),
		header: {
			titleType: 2,
			titleContent: 'nav.feedback.history',
		},
	},
	{
		path: '/FeedbackDetail',
		element: (
			<ProtectedRoute
				children={<FeedbackDetail key="FeedbackDetail" />}
				reqAuth
			/>
		),
		header: {
			titleType: 2,
			titleContent: 'nav.feedback.detail',
		},
	},
	{
		path: '/GetHelp',
		element: (
			<ProtectedRoute children={<OrienticaGetHelp key="GetHelp" />} />
		),
		header: {
			titleType: 1,
		},
	},
	{
		path: '/Timeout',
		element: (
			<ProtectedRoute
				children={<OrienticaGetHelp key="Timeout" timeout />}
			/>
		),
		header: {
			titleType: 1,
		},
	},
	{
		path: '/FAQ',
		element: <ProtectedRoute children={<FAQ key="FAQ" />} />,
		header: {
			titleType: 1,
		},
	},
	{
		path: '/ownershipTimeline',
		element: <ProtectedRoute children={<OwnershipTimeline />} reqProduct />,
		header: {
			titleType: 2,
			titleContent: 'ownershipTimeline.title',
		},
	},
	{
		path: '*',
		element: <NotFound />,
		header: {
			titleType: 0,
			titleContent: 'nav.notfound',
		},
	},
];
